import { type ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from '@mp/graphql/generated';
import { useGraphQLQuery } from '@mp/hooks/useGraphQLRequest';

const CurrentUserGql = graphql(`
  query GetCurrentUserForExperience {
    me {
      professional {
        id
        kinds
      }
    }
  }
`);

const AssignmentRequestsGql = graphql(`
  query GetAssignmentRequestsForExperience($input: AssignmentRequestQueryInput) {
    assignmentRequests(input: $input) {
      id
    }
  }
`);

type CurrentUserProps = ResultOf<typeof CurrentUserGql>;

type AssignmentRequestsProps = ResultOf<typeof AssignmentRequestsGql>;

const useCurrentUserForExperience = () => {
  const { data: currentUserData, isLoading } = useGraphQLQuery<CurrentUserProps>({
    operationName: 'GetCurrentUserForExperience',
    query: CurrentUserGql,
    variables: {},
  });
  const currentUser = currentUserData?.me;

  return { currentUser, isLoading };
};

export const useAssignmentRequestsForWorkGapForm = (assignmentId?: number) => {
  const { currentUser } = useCurrentUserForExperience();
  const professional_id = currentUser?.professional?.id;
  const assignment_id = assignmentId;
  const enabled = assignment_id === undefined ? true : !!assignment_id;

  const { data, isLoading } = useGraphQLQuery<AssignmentRequestsProps>({
    operationName: 'GetAssignmentRequestsForExperience',
    query: AssignmentRequestsGql,
    variables: {
      input: { filter: { assignment_id }, orderBy: { updated_at: false } },
      professional_id,
    },
    enabled,
  });
  const assignmentRequests = data?.assignmentRequests ?? [];

  return { assignmentRequests, isLoading };
};
